import ComponentLayout from "../../../../src/layouts/component-layout";
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import { HeadingTags } from '@primer/react-brand';
import { Box as Container } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import { Label } from '@primer/react';
import * as React from 'react';
export default {
  ComponentLayout,
  InlineCode,
  HeadingTags,
  Container,
  PropTableValues,
  Label,
  React
};